import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import QuoteSection from '../components/QuoteSection';
import LightboxModal from '../components/LightboxModal';
import { companyInfo } from '../data/siteData';
import { imageUrl } from '../lib/images';

export default function TraebeklaedtHegnPage() {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const images = [
    { src: "/_assets/fb-img-1760014060550.jpg", title: "Træbeklædt hegn" },
    { src: "/_assets/fb-img-1760014086552-0.jpg", title: "Træbeklædt hegn have" },
  ];

  return (
    <>
      <SEO
        title="Træbeklædt hegn - Et naturligt valg | Hovendals"
        description="Naturligt, tidløst og charmerende Et træbeklædt hegn er et klassisk valg, der bringer varme og karakter til enhver have. Den naturlige træstruktur giver et levende og indbydende udtryk, som passer perfekt til både moderne og traditionelle boliger. Hos Hovendals ApS oplever vi, at mange kunder vælger træbeklædte hegn for at bevare et mere naturligt og organisk look omkring deres hjem."
        ogImage="/_assets/fb-img-1760014086552.jpg"
      />

      {/* Hero */}
      <section className="relative py-20 bg-slate-900 text-white overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-25">
          <img
            src={imageUrl("/_assets/fb-img-1760014086552.jpg", "width=1600,quality=80,format=auto")}
            alt="Træbeklædt hegn"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-[#004fa4]/20 text-[#c2ccdf] border border-[#004fa4]/30">
              <i className="fa-sharp fa-solid fa-tree" aria-hidden="true"></i>
              <span>Klassisk og levende</span>
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-tight">
              Træbeklædt hegn - Et naturligt valg
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed font-normal">
              Naturligt, tidløst og charmerende hegn kombineret med stærke stålstolper.
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="space-y-6">
              <div>
                <span className="text-xs font-bold uppercase tracking-wider text-[#004fa4]">Træets varme & karakter</span>
                <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight mt-1">
                  Naturligt, tidløst og charmerende
                </h2>
              </div>
              <p className="text-slate-700 leading-relaxed text-base">
                Et træbeklædt hegn er et klassisk valg, der bringer varme og karakter til enhver have. Den naturlige træstruktur giver et levende og indbydende udtryk, som passer perfekt til både moderne og traditionelle boliger. Hos Hovendals ApS oplever vi, at mange kunder vælger træbeklædte hegn for at bevare et mere naturligt og organisk look omkring deres hjem.
              </p>

              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">
                  Træhegn med moderne udtryk og holdbare materialer
                </h3>
                <p className="text-slate-700 leading-relaxed text-base">
                  Vores træbeklædte hegn er bygget med fokus på kvalitet og stabilitet. De solide metalstolper giver et moderne udtryk og sikrer, at hegnet står fast i al slags vejr, mens træbeklædningen skaber en varm kontrast. Vi anvender træsorter, der er velegnede til det danske klima, og som med den rette pleje kan holde sig flotte i mange år.
                </p>
              </div>

              <div className="flex flex-wrap gap-4 pt-2">
                <a
                  href={`tel:${companyInfo.phoneFormatted}`}
                  className="px-6 py-3 rounded-lg bg-[#004fa4] hover:bg-[#183e7f] text-white font-medium text-sm shadow-sm transition-all flex items-center gap-2"
                >
                  <i className="fa-sharp fa-solid fa-phone" aria-hidden="true"></i>
                  <span>Ring: {companyInfo.phone}</span>
                </a>
                <Link
                  to="/kontakt"
                  className="px-6 py-3 rounded-lg bg-slate-900 hover:bg-slate-800 text-white font-bold text-sm transition-all flex items-center gap-2"
                >
                  <i className="fa-sharp fa-solid fa-paper-plane" aria-hidden="true"></i>
                  <span>Få et tilbud</span>
                </Link>
              </div>
            </div>

            <div className="relative rounded-2xl overflow-hidden shadow-xl border-4 border-white bg-slate-100">
              <img
                src={imageUrl("/_assets/fb-img-1760014060550.jpg", "width=800,quality=85,format=auto")}
                alt="Træbeklædt hegn"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          {/* Section: Efter dine mål */}
          <div className="bg-slate-50 rounded-2xl p-8 sm:p-12 border border-slate-200/80 mb-16">
            <div className="max-w-3xl space-y-4">
              <span className="text-xs font-bold uppercase tracking-wider text-[#004fa4]">Skræddersyet løsning</span>
              <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
                Skræddersyet træbeklædt hegn efter dine mål
              </h2>
              <p className="text-[#4B515D] leading-relaxed text-base">
                Hos Hovendals fremstiller vi træbeklædte hegn på mål med fokus på kvalitet, holdbarhed og flot design. Vi leverer skræddersyede løsninger til kunder i hele Danmark.
              </p>
              <p className="text-slate-700 leading-relaxed text-base">
                Helt lavpraktisk betyder det, at vi kommer ud til dig, måler op, hvorefter vi laver hegnet på vores værksted. Du er derfor sikret, at hegnet er 100% designet efter din haves mål samt dine ønsker til hegnet. Når hegnet er færdigt, kommer vi ud og monterer det på adressen, så du hurtigt kan nyde godt af dit nye hegn. <Link to="/kontakt" className="text-[#004fa4] font-bold hover:underline">Kontakt os</Link> og få en skarp pris på dit nye Træbeklædte hegn inkl. montering.
              </p>
              <p className="text-slate-700 leading-relaxed text-base">
                Herunder har vi samlet et udpluk af træbeklædte, vi har lavet. Designet varierer efter kundens ønske, så det passer til deres stil og drømme.
              </p>
            </div>
          </div>

          {/* Galleri */}
          <div className="mb-12">
            <h3 className="text-2xl font-bold text-slate-900 mb-2">
              Udpluk af træbeklædte hegn
            </h3>
            <p className="text-sm text-slate-600 mb-6">
              Klik for at forstørre billederne.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-2xl">
              {images.map((img, idx) => (
                <div
                  key={idx}
                  onClick={() => setLightboxIndex(idx)}
                  className="group relative h-64 rounded-xl overflow-hidden bg-slate-100 cursor-pointer shadow-sm hover:shadow-md transition-all"
                >
                  <img
                    src={imageUrl(img.src, "width=600,quality=80,format=auto")}
                    alt={img.title}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-slate-950/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center text-white">
                    <span className="p-2.5 rounded-full bg-[#143463]/90 text-white text-sm">
                      <i className="fa-sharp fa-solid fa-magnifying-glass-plus" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <QuoteSection />

      {/* Lightbox modal */}
      <LightboxModal
        images={images}
        currentIndex={lightboxIndex}
        onClose={() => setLightboxIndex(null)}
        onNavigate={(index) => setLightboxIndex(index)}
      />
    </>
  );
}
